import React, {useEffect, useState } from "react";
import { getAllLeads, getAllContacts, getAllCustomers, addLead, } from "../../utils/helper";
import Loader from "../../utils/Loader";
import { useHistory } from "react-router-dom";
import { alertSuccess, alertError } from '../../utils/alerts';
import { Link } from "react-router-dom/cjs/react-router-dom";

const INIT_STATE = {
    customer: null,
    contact: null,
    source: null,
    service: null,
    lastContactDate: null,
    nextContactDate: null,
    comment: null,
};

export default function Leads() {
    const [loading, setLoading] = useState(false);
    const [leads, setLeads] = useState(null);
    const [contacts, setContacts] = useState(null);
    const [customers, setCustomers] = useState(null);
    const history = useHistory();
    const [state, setState] = useState(INIT_STATE);

    const navigateById = (path, id) => {
        history.push(`${path}/${id}`);
    };

    useEffect(() => {
        setLoading(true);
        getAllLeads()
            .then((res) => { 
                setLeads(res.data.data);  
                setTimeout(() => {
                    setLoading(false)
                }, 3500);
            })
            .catch((err) => {
                console.log(err?.response)
                setTimeout(() => {
                    setLoading(false)
                }, 3500);
            });
    }, []);

    useEffect(() => {
        getAllCustomers()
            .then((res) => {
                if(res.data.success){
                    setCustomers(res.data.data);  
                } 
            })
            .catch((err) => {
                console.log(err?.response)
            });
    }, []);


    useEffect(() => {
        getAllContacts()
            .then((res) => {
                if(res.data.success){
                    setContacts(res.data.data);  
                } 
            })
            .catch((err) => {
                console.log(err?.response)
            });
    }, []);

    const handleChange = (e) => {
        e.persist();
        setState((prev) => ({
            ...prev,
            [e.target.name]: e.target.value,
        }));
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        const data = { ...state };
        if(data.source && data.customer && data.contact && data.service && data.lastContactDate && data.nextContactDate && data.comment){
            setLoading(true);
            addLead(data)
            .then((res) => {
                if(res.data.success){
                    alertSuccess(res.data.message);
                    window.location.reload();
                } else {
                    alertError(res.data.message)
                }
                setLoading(false);
                setTimeout(() => {
                    setLoading(false);
                }, 1500);
            })
            .catch((err) => {
                alertError(err?.response?.data?.error);
                setLoading(false);
            });
        }
    };

    return (
        <>
            <div className="spur-card-menu">
                <button data-toggle="modal" data-target="#modal" type="button" className="pull-right btn topbtn btn-primary">CREATE</button>
            </div>
            
            <h1 className="dash-title"><Link to="/sales" style={{color: '#454545'}}><i className="fa fa-arrow-left"></i> Go Back</Link></h1>

            <div className="row dash-row">
                
                <div className="col-md-12 col-sm-12 col-12">
                    <div className="card spur-card" style={{marginTop: 5}}>
                        <div className="card-header">
                            <div className="spur-card-title">Leads</div>
                        </div>
                        <div className="card-body">
                            <div className="my_profile">
                                {(!loading && leads && leads) ? 
                                    <div className="table-responsive">
                                        {(leads && leads.length > 0) ?
                                        <table className="table text-left text-caps table-bordered" id="myTable">
                                            <thead><tr><th>SN</th><th>Customer</th><th>Contact</th><th>Source</th><th>Service</th><th>Stage</th><th>View</th></tr></thead>
                                            <tbody>
                                                {leads && leads.map((row, index) => 
                                                    <tr key={index}>
                                                        <td>{index + 1}</td>
                                                        <td>{row?.customer && row?.customer?.name}</td>
                                                        <td>{row?.contact && row?.contact?.name}</td>
                                                        <td>{row?.source && row?.source}</td>
                                                        <td>{row?.service && row?.service}</td>
                                                        <td>{(row?.stage === "suspect") || (row?.stage === "lost") ? 
                                                            <span className="badge badge-danger">{row.stage}</span> : (
                                                                (row?.stage === "prospect") ? (
                                                                    <span className="badge badge-warning">{row.stage}</span>
                                                                ) : (
                                                                    <span className="badge badge-success">{row.stage}</span>
                                                                )
                                                            )
                                                        }</td>

                                                        <td>
                                                            <button 
                                                                className='btn btn-preview'
                                                                onClick={() => navigateById("/sales/lead", row._id)} 
                                                            >
                                                                    <i className="fa fa-eye"></i> View
                                                            </button>
                                                        </td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </table> : 
                                        <div className="alert alert-danger myerror d-block">No record found.</div> }
                                    </div>
                                : <Loader /> }
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            
            <div id="modal" className="modal fade" role="dialog">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h4 className="modal-title">ADD LEAD</h4>
                            <button type="button" className="close" data-dismiss="modal">&times;</button>
                        </div>
                        <div className="modal-body">
                            <div className="row">
                                <div className="col-md-6 form-group">
                                    <label className="control-label">Customer <span>*</span></label>
                                    <select className="form-control form-select" name="customer" id="customer" required 
                                    onChange={handleChange} defaultValue={state.customer && state.customer} disabled={loading}>
                                        <option value=''>Select...</option>
                                        {customers && customers.map((item, i) => (
                                            <option key={i} value={item._id}>{item.name}</option>
                                        ))}
                                    </select>
                                </div>
                                <div className="col-md-6 form-group">
                                    <label className="control-label">Contact <span>*</span></label>
                                    <select className="form-control form-select" name="contact" id="contact" required 
                                    onChange={handleChange} defaultValue={state.contact && state.contact} disabled={loading}>
                                        <option value=''>Select...</option>
                                        {contacts && contacts.map((item, i) => (
                                            <option key={i} value={item._id}>{item.name}</option>
                                        ))}
                                    </select>
                                </div>
                                <div className="col-md-6 form-group">
                                    <label className="control-label">Lead Source <span>*</span></label>
                                    <select className="form-control form-select" name="source" id="source" required 
                                    onChange={handleChange} defaultValue={state.source && state.source} disabled={loading}>
                                        <option value=''>Select...</option>
                                        <option value="Return Customer">Return Customer</option>
                                        <option value="Customer Inquiry">Customer Inquiry</option>
                                        <option value="Website Traffic">Website Traffic</option>
                                        <option value="Referrals">Referrals</option>
                                        <option value="Sales Call">Sales Call</option>
                                        <option value="Event Networking">Event Networking</option>
                                    </select>
                                </div>
                                <div className="col-md-6 form-group">
                                    <label className="control-label">Service Delivery <span>*</span></label>
                                    <select className="form-control form-select" name="service" id="service" required 
                                    onChange={handleChange} defaultValue={state.service && state.service} disabled={loading}>
                                        <option value=''>Select...</option>
                                        <option value="Recruitment and Selection">Recruitment and Selection</option>
                                        <option value="Outsourcing">Outsourcing</option>
                                        <option value="Advisory">Advisory</option>
                                        <option value="Learning and Development">Learning and Development</option>
                                        <option value="Technology Service">Technology Service</option>
                                    </select>
                                </div>
                                <div className="col-md-6 form-group">
                                    <label className="control-label">Last Contact Date <span>*</span></label>
                                    <input type="date" name="lastContactDate" 
                                        className="form-control" required 
                                        placeholder="Last Contact Date" 
                                        onChange={handleChange} defaultValue={state.lastContactDate && state.lastContactDate }  
                                        disabled={loading} 
                                    />
                                </div>
                                <div className="col-md-6 form-group">
                                    <label className="control-label">Next Contact Date <span>*</span></label>
                                    <input type="date" name="nextContactDate" className="form-control" required placeholder="Next Contact Date" 
                                     onChange={handleChange} defaultValue={state.nextContactDate && state.nextContactDate }  
                                     disabled={loading} />
                                </div>
                                <div className="col-md-12 form-group">
                                    <label className="control-label">Comment/Notes <span>*</span></label>
                                    <textarea 
                                        cols="33" 
                                        rows="3" 
                                        name="comment" 
                                        className="form-control" 
                                        required 
                                        placeholder="Comment/Notes" 
                                        disabled={loading} 
                                        onChange={handleChange} 
                                        defaultValue={state.comment || ""}
                                    >
                                    </textarea>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-12 form-group">
                                    <button 
                                        type="submit" 
                                        className="btn" 
                                        disabled={loading}
                                        onClick={handleSubmit} >Create</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div> 
        </>
    );
}
